import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import OrganisationEdit from '../OrganisationEdit'
import Loading from '../Loading'

import * as superAdminActions from '../../ducks/super-admin'

class OrganisationEditContainer extends React.Component {
  componentDidMount() {
    this.props.actions.fetchOrganisation(this.props.routeParams.id)
  }

  render() {
    if (!this.props.organisation) {
      return <Loading />
    }

    return (
      <OrganisationEdit
        organisation={this.props.organisation}
        accountOrganisation={this.props.accountOrganisation}
        onUpdate={this.props.actions.updateOrganisation}
        onDelete={this.props.actions.deleteOrganisation}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    organisation: state.superAdmin.get('organisation'),
    accountOrganisation: state.account.get('originalOrganisation').organisation
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(superAdminActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OrganisationEditContainer)



// WEBPACK FOOTER //
// ./src/components/smart/OrganisationEditContainer.js